// ABOUTME: Keyed registry of grouping presets for ShDataGrid3 columns — same pattern as WEBSHOP_FILTER_KEYS in Filter.js.
// ABOUTME: Usage: `grouping: GROUPING_PRESETS.CREATED_AT` in a column def.

import {
    CREATED_AT_GRANULARITIES,
    CreatedAtLabel,
    CreatedAtPreview,
} from "./CreatedAt";
import { OrderStateLabel, OrderStatePreview } from "./OrderState";
import { ShipperLabel, ShipperPreview } from "./Shipper";

const CREATED_AT = {
    granularities: CREATED_AT_GRANULARITIES,
    renderLabel: (key) => <CreatedAtLabel groupKey={key} />,
    preview: <CreatedAtPreview />,
};

const ORDER_STATE = {
    renderLabel: (key) => <OrderStateLabel groupKey={key} />,
    preview: <OrderStatePreview />,
};

const SHIPPER = {
    toKey: (value) => JSON.stringify(value),
    renderLabel: (key) => <ShipperLabel groupKey={typeof key === "string" ? JSON.parse(key) : key} />,
    preview: <ShipperPreview />,
};

export const RELATION_ORDERS_DEFAULT = {
    CREATED_AT,
    ORDER_STATE,
    SHIPPER
};
